export { default as CopyIcon } from './CopyIcon';
